
import React from 'react';
import { Box, Stepper, Step, StepLabel, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomStepIcon from '../utils/CustomStepIcon';

interface AssistantStepperProps {
  activeStep: number;
  customerConnected: boolean;
  vehicleExists: boolean;
}

const AssistantStepper = ({ activeStep, customerConnected, vehicleExists }: AssistantStepperProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const steps = [
    t('assistant.steps.customerNumber'),
    t('assistant.steps.customerConnect'),
    t('assistant.steps.vehicleIdentification'),
    t('assistant.steps.vehicleDetails'),
    t('assistant.steps.device'),
    t('assistant.steps.review')
  ];

  const isStepSkipped = (step: number) => {
    if (step === 1 && customerConnected) return true;
    if (step === 3 && vehicleExists) return true;
    return false;
  };

  return (
    <Box sx={{
      p: isMobile ? 0.5 : 2,
      py: isMobile ? 1.5 : 2,
      borderBottom: 1,
      borderColor: 'divider',
      // Only enable horizontal scrolling if content doesn't fit
      overflowX: isMobile ? 'visible' : 'auto',
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{
          width: isMobile ? 'auto' : '100%',
          '& .MuiStepLabel-label': {
            fontSize: '0.875rem',
            mt: 1,
            // Hide labels completely on mobile
            display: isMobile ? 'none' : 'block'
          },
          '& .MuiStepLabel-iconContainer': {
            // Adjust padding around the icon on mobile
            p: isMobile ? '0 8px' : '0 16px'
          },
          '& .MuiStep-root': {
            p: isMobile ? '0 6px' : '0 8px'
          }
        }}
      >
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean; disabled?: boolean } = {};
          if (isStepSkipped(index)) {
            stepProps.disabled = true;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel StepIconComponent={CustomStepIcon}>
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default AssistantStepper;
